import L from 'leaflet';

class map {
  constructor(context) {
    context.querySelectorAll('[data-map]').forEach(element => {
      const map = L.map(element.querySelector('.leaflet'), {
        center: [49.6097822, 6.1271673],
        zoom: 16,
        scrollWheelZoom: false
      });

      const mapLink = '<a href="http://openstreetmap.org">OpenStreetMap</a>';
      L.tileLayer(
        'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; ' + mapLink + ' Contributors',
        maxZoom: 18,
      }).addTo(map);

      let bounds = [];
      element.querySelectorAll('[data-map-marker-id]').forEach(marker => {
        // Popup
        const title = `<strong>${marker.dataset.mapMarkerName}</strong>`;
        const lat = marker.dataset.mapMarkerLat;
        const long = marker.dataset.mapMarkerLon;
        bounds.push([lat, long]);

        const mapMarker = L.marker([lat, long], {
          icon: new L.DivIcon({
            className: `map__icon map__icon--${marker.dataset.mapMarkerType}`,
            html: `<span>${marker.dataset.mapMarkerIndex}</span>`,
            iconSize: [30, 30]
          })
        }).addTo(map).bindPopup(`${title}`).on('click', e => {
          map.setView(e.target.getLatLng(), 16);
        });

        marker.addEventListener('click', (e) => {
          e.preventDefault();
          mapMarker.openPopup();
          map.setView(mapMarker.getLatLng(), 16);
          return false;
        });

      });

      map.fitBounds(bounds);
    });
  }
};

export default map;